import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton, TableFilter, QueryDropdown, BaasicModal, BaasicTable, BasicCheckbox,BasicQueryCheckbox, DateQueryPicker } from 'core/components';
import { Content, PageFooter, PageNavigation, Page } from 'core/layouts';
import { OrderingTaskEdit } from 'application/dashboard/pages';

import { Calendar, Generate, CalendarEventEdit, ChangeDateModal} from 'application/schedule/components';
import { isSome } from 'core/utils';
import { Tooltip as ReactTooltip } from "react-tooltip";

function ScheduleCalendarTemplate({ viewStore, t }) {
    const {
        queryUtility,
        goToSchedules,
        calendarStore, 
        facilityStore,
        corporateStore,
        accountRepStore,
        billerRepStore,
        payorRepStore,
        intakeRepStore,
        documentRepStore,
        isLoading,
        generateModal,
        openGenerateModal,
        regenerateTasks,
        eventEditModal,
        togglePreview,
        tableStore,
        calendarSelected,
        rootStore,
        typeStore,
        onTypeChange,
        calendarType,
        sortByAcc,
        onSortByAccChange,
        orderingTaskModal,
        changeDateModal,
        isNewCheckboxStore,
        showPreviousDatesCheckboxStore,
        onShowPreviousDatesChange,
        isWoundCareCheckboxStore,
        showCompletedCheckboxStore,
        datePickerStore,
        changeDates,
        filterOnChange
    } = viewStore;
    return ( 
        <Page store={viewStore} className="container">
            <PageNavigation title={calendarType && calendarType.name} >
                {rootStore.userStore.user && rootStore.userStore.user.roles.includes("Administrators") && !calendarSelected && 
                    <BaasicButton
                        className={"btn btn--base btn--primary" + (calendarType && calendarType.abrv ? " btn--" + calendarType.abrv : "")}
                        label={'Change Date'} 
                        onClick={() => changeDates()}
                        authorized={rootStore.permissionStore.hasPermission('calendarSection.create')}
                        disabled={!tableStore.hasSelectedItems}
                    />
                }
                {rootStore.userStore.user && rootStore.userStore.user.roles.includes("Administrators") &&
                    <BaasicButton
                        className={"btn btn--base btn--primary" + (calendarType && calendarType.abrv ? " btn--" + calendarType.abrv : "")}
                        label={'Regenerate tasks'} 
                        onClick={() => regenerateTasks()}
                        authorized={rootStore.permissionStore.hasPermission('calendarSection.create')}
                    />  
                }
                <BaasicButton
                    className={"btn btn--base btn--primary" + (calendarType && calendarType.abrv ? " btn--" + calendarType.abrv : "")}
                    label={'Generate Dates'} 
                    onClick={() => openGenerateModal()}
                    authorized={rootStore.permissionStore.hasPermission('calendarSection.create')}
                /> 
                {/* <BaasicButton
                    className={deliveryCalendarSelected ? 'btn btn--base btn--primary u-mar--right--sml' : 'btn btn--base btn--primary btn--delivery u-mar--right--sml'}
                    label={deliveryCalendarSelected ? 'View Ordering Calendar' : 'View Delivery Calendar'} 
                    icon={deliveryCalendarSelected ? 'u-icon u-icon--med u-icon--order u-mar--right--sml' : 'u-icon u-icon--med u-icon--delivery u-mar--right--sml'}
                    onClick={() => toggleCalendar()}
                />   */}
                <BaasicButton
                    className={"btn btn--base btn--primary" + (calendarType && calendarType.abrv ? " btn--" + calendarType.abrv : "")}
                    label={calendarSelected ? 'View List' : 'View Calendar'} 
                    icon={calendarSelected ? 'u-icon u-icon--sml u-icon--sub u-icon--list-view' : 'u-icon u-icon--xmed u-icon--sub u-icon--calendar-view'}
                    onClick={() => togglePreview()}
                />  
            </PageNavigation>
            <Content loading={isLoading}>
                <div>
                    <div className='u-mar--bottom--sml'>
                        <TableFilter queryUtility={queryUtility} showSearchFilter={false} filterVisible={true} >
                            <div className="col col-sml-12 col-med-6 col-xxlrg-3 u-mar--bottom--sml">
                                <QueryDropdown clearable={false}  queryUtility={queryUtility} store={typeStore} propertyName="calendarTypeId" label="Calendar Type" onChange={onTypeChange} />
                            </div>
                            <div className="col col-sml-12 col-med-6 col-xxlrg-3 u-mar--bottom--sml">
                                <QueryDropdown queryUtility={queryUtility} onChange={() => filterOnChange(accountRepStore)} store={accountRepStore} propertyName="accountRepId" label="Account Manager" />
                            </div> 
                            <div className="col col-sml-12 col-med-6 col-xxlrg-3 u-mar--bottom--sml">
                                <QueryDropdown queryUtility={queryUtility} onChange={() => filterOnChange(intakeRepStore)} store={intakeRepStore} propertyName="intakeRepId" label="Intake Specialist" />
                            </div>
                            <div className="col col-sml-12 col-med-6 col-xxlrg-3 u-mar--bottom--sml">
                                <QueryDropdown queryUtility={queryUtility} onChange={() => filterOnChange(payorRepStore)} store={payorRepStore} propertyName="payorRepId" label="Insurance Specialist" />
                            </div>
                            <div className="col col-sml-12 col-med-6 col-xxlrg-3 u-mar--bottom--sml">
                                <QueryDropdown queryUtility={queryUtility} onChange={() => filterOnChange(documentRepStore)} store={documentRepStore} propertyName="documentRepId" label="Clinical Review" />
                            </div>
                            <div className="col col-sml-12 col-med-6 col-xxlrg-3 u-mar--bottom--sml">
                                <QueryDropdown queryUtility={queryUtility} onChange={() => filterOnChange(billerRepStore)} store={billerRepStore} propertyName="billerRepId" label="Biller" />
                            </div>
                            <div className="col col-sml-12 col-med-6 col-xxlrg-3 u-mar--bottom--sml">
                                <QueryDropdown queryUtility={queryUtility} onChange={() => filterOnChange(facilityStore)} store={facilityStore} propertyName="facilityId" label="Facility" />
                            </div>
                            <div className="col col-sml-12 col-med-6 col-xxlrg-3 u-mar--bottom--sml">
                                <QueryDropdown queryUtility={queryUtility} onChange={() => filterOnChange(corporateStore)} store={corporateStore} propertyName="corporateId" label="Corporate" />
                            </div>
                            { 
                                !calendarSelected && 
                                <div className="col col-sml-12 col-med-6 col-xxlrg-3 u-mar--bottom--sml">
                                    <label className="form__group__label">Date</label>
                                    <DateQueryPicker store={datePickerStore} queryUtility={queryUtility} propertyName="date" />
                                </div>
                            }
                            <div className={(!calendarSelected ? "col col-sml-12 col-med-6 col-xxlrg-9" : "col col-sml-12 col-med-12 col-xxlrg-12 u-mar--bottom--tny") + " u-flex--self--center"}>
                                <div className="u-flex--primary">
                                    <div className="u-mar--right--med">
                                        <BasicQueryCheckbox id='isNew' queryUtility={queryUtility} propertyName='isNew' label='Show Only New' store={isNewCheckboxStore}/>
                                    </div>
                                    <div className="u-mar--right--med">
                                        <BasicQueryCheckbox id='showPreviousDates' queryUtility={queryUtility} propertyName='showPreviousDates' label='Show Previous Dates' store={showPreviousDatesCheckboxStore} onChange={onShowPreviousDatesChange} />
                                    </div>
                                    <div className="u-mar--right--med">
                                        <BasicQueryCheckbox id='isWoundCare' queryUtility={queryUtility} propertyName='isWoundCare' label='Show Wound Care' store={isWoundCareCheckboxStore} />
                                    </div>
                                    { 
                                        !calendarSelected && 
                                        <div className="u-mar--right--med">
                                            <BasicQueryCheckbox id='showCompleted' queryUtility={queryUtility} propertyName='showCompleted' label='Show Completed' store={showCompletedCheckboxStore}/>
                                        </div>
                                    }
                                </div>
                            </div>
                        </TableFilter>
                    </div>
                    
                    {calendarSelected ? 
                    <div>
                        <div className="u-mar--bottom--med">
                            <BasicCheckbox label='Sort by Account Representative' checked={sortByAcc} onChange={onSortByAccChange} id='sortByAcc' />
                        </div>
                        <div className="card card--form card--primary card--med">
                            <div className={'calendar__wrap' + (calendarType && calendarType.abrv ?  ' is-' + calendarType.abrv : '')}>
                                <Calendar store={calendarStore} />
                            </div>
                        </div>
                    </div>
                    :
                    <React.Fragment>
                        <div className={'card--table' + (calendarType && calendarType.abrv ? ' card--table--' + calendarType.abrv : '')}>
                            <BaasicTable
                                tableStore={tableStore}
                                loading={isLoading} 
                                //authorization={authorization}        
                                actionsComponent={renderActions}                   
                            />
                        </div>
                        <BaasicModal className="modal__content ReactModal__Content--small" modalParams={changeDateModal}>
                            <ChangeDateModal />
                        </BaasicModal>
                    </React.Fragment>
                    }
                    
                </div>
                <PageFooter>
                    <BaasicButton
                        className='btn btn--base btn--ghost'
                        label={t('PREVIEW_LAYOUT.CANCEL_BUTTON')}
                        onClick={goToSchedules}
                    />
                </PageFooter>

                <ReactTooltip positionStrategy="fixed" id="scheduleCalendarTooltip" float={true} />

                <BaasicModal modalParams={generateModal}>
                    <Generate />
                </BaasicModal>

                <BaasicModal className="modal__content modal--lrg" modalParams={eventEditModal}>
                    <CalendarEventEdit />
                </BaasicModal>
                
                <BaasicModal modalParams={orderingTaskModal} className="modal__content modal--lrg">
                    <OrderingTaskEdit />
                </BaasicModal>
            </Content>
            
        </Page>
    )
}

function renderActions({item, actions}){
    if (!isSome(actions)) return null;
    const { onEdit, onDelete, onChangeDate } = actions;
    if (!isSome(onEdit) && !isSome(onDelete) && !isSome(onChangeDate)) return null;

    return (
        <td className="table__body--data right">
            <div className="table__icons">  
                {isSome(onChangeDate) ? (
                    <BaasicButton
                        authorized={item.hasUpdatePermission}
                        className="btn btn--icon"
                        icon='u-icon u-icon--schedule u-icon--sml'
                        label='Change Date'
                        onlyIcon={true}
                        onClick={() => onChangeDate(item)}
                        >
                    </BaasicButton>
                ) : null}
                {isSome(onEdit) ? (
                    <BaasicButton
                        authorized={item.hasUpdatePermission}
                        className="btn btn--icon"
                        icon='u-icon u-icon--edit u-icon--sml'
                        label='LIST_LAYOUT.EDIT_BUTTON'
                        onlyIcon={true}
                        onClick={() => onEdit(item)}>
                    </BaasicButton>
                ) : null}
                {isSome(onDelete) ? (
                    <BaasicButton
                        authorized={item.hasUpdatePermission}
                        className="btn btn--icon is-delete"
                        icon='u-icon u-icon--delete u-icon--sml'
                        label='LIST_LAYOUT.DELETE_BUTTON'
                        onlyIcon={true}
                        onClick={() => onDelete(item)}>
                    </BaasicButton>
                ) : null}
            </div>
        </td>
    );

}

renderActions.propTypes = {
    item: PropTypes.object,
    actions: PropTypes.object
};

ScheduleCalendarTemplate.propTypes = {
    viewStore: PropTypes.object,
    t:PropTypes.func
};

export default defaultTemplate(ScheduleCalendarTemplate);
